import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skip } from 'rxjs/operators';

import { Licenciador } from 'src/app/models/api/comercial/licenciador';
import { ApiLicenciadorService } from 'src/app/services/api/comercial/api-licenciador-service';
import { IPaginator } from 'src/app/ui/paginator/paginator.component';

@Component({
  selector: 'c-licensor',
  templateUrl: './licensor.component.html',
  styleUrls: ['./licensor.component.scss']
})
export class LicensorComponent implements OnInit {
  licensorData: LicensorEditable[];
  licensorPaginatedData: LicensorEditable[];
  licensorFilteredData: LicensorEditable[];
  columns: string[] = ['name', 'active', 'actions'];
  form: FormGroup;
  paginator$ = new BehaviorSubject<IPaginator>({
    isLastPage: false,
    page: 1,
    pageLength: 25,
    total: 0
  });
  search$ = new BehaviorSubject('');
  constructor(
    private apiLicenciador: ApiLicenciadorService,
    private fb: FormBuilder,
  ) {
    this.createForm();
    this.listenPaginator();
    this.listenSearch();
  }

  ngOnInit() {
    this.loadLicensorData();
  }

  createForm() {
    this.form = this.fb.group({
      descricao: [null],
      ativo: [null]
    });
  }

  loadLicensorData() {
    this.apiLicenciador.getAllAtivosInativos().subscribe(res => {
      this.licensorData = res.data as LicensorEditable[];
      this.paginate(this.paginator$.value);
    });
  }

  edit(data: LicensorEditable) {
    data.newDescription = data.descricao;
    data.isEditActive = true;
  }

  cancelEdit(data: LicensorEditable) {
    data.newDescription = data.descricao;
    data.isEditActive = false;
  }

  async save(data: LicensorEditable) {
    if (!data) {
      const licensor: LicensorEditable = this.form.value;
      licensor.descricao = licensor.descricao;
      licensor.ativo = true;

      await this.apiLicenciador.insert(licensor).toPromise();
      this.form.reset();
      this.loadLicensorData();
    } else {
      const description = data.newDescription;

      await this.apiLicenciador.update({
        id: data.id, descricao: description, ativo: data.ativo
      }).toPromise();
      data.descricao = description;
      data.isEditActive = false;
    }
  }

  async changeEnableDisable(data: LicensorEditable) {
    try {
      await this.apiLicenciador.delete(data.id).toPromise();
    } catch {
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    }
  }

  private listenSearch() {
    this.search$.pipe(skip(1), debounceTime(800)).subscribe((res) => {
      if (res) {
        this.licensorFilteredData = this.licensorData.filter(elem => {
          const regex = new RegExp(res.normalize('NFD').replace(/[\u0300-\u036f]/g, ''), 'i');
          const licensor = regex.test(elem.descricao.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
          return licensor;
        });
      } else {
        this.licensorFilteredData = undefined;
      }
    });
  }

  private listenPaginator() {
    this.paginator$.subscribe(res => {
      this.paginate(res);
    });
  }

  private paginate(data: IPaginator) {
    if (this.licensorData) {
      const startAt = (data.page - 1) * data.pageLength;
      this.licensorPaginatedData = this.licensorData.slice(startAt, startAt + data.pageLength);
    }
  }

  get canCreate() {
    return this.descricao.value;
  }
  get descricao() { return this.form.get('descricao'); }
}

interface LicensorEditable extends Licenciador {
  isEditActive: boolean;
  newDescription: string;
}